
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class PatientFeatureAccessibleMixin extends Mixins() {
  get isPatientFeatureEnable(): boolean {
    // 固定の場合は患者機能を使わないと判断.万一固定だけど使うというユースケースがあった場合は設定を見直し.
    return !this.$configuration.behavior.patient.fixed.isEnable && this.$configuration.behavior.patient.feature.isEnable;
  }
}
